var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.active
    ? _c(
        "div",
        {
          staticClass: "global-modal",
          class: {
            "no-background": _vm.transparentBg,
            "full-size": _vm.fullsize,
            landscape: _vm.isMobileLandscape,
            desktop: !_vm.isMobile,
          },
          style: {
            "justify-content": _vm.renderVAlign,
            "align-items": _vm.renderAlign,
            background: _vm.hasBg ? "rgba(2, 8, 24, 0.62)" : "transparent",
          },
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              $event.stopPropagation()
              return _vm.clickOutside.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-container",
              class: { "has-menu-bg": _vm.useMenuBg },
              style: [
                {
                  width: _vm.size,
                  height: _vm.height,
                  "overflow-y": _vm.allowScroll,
                },
                {
                  "border-top-left-radius": _vm.getBorderRadiusBySides(0),
                  "border-top-right-radius": _vm.getBorderRadiusBySides(1),
                  "border-bottom-right-radius": _vm.getBorderRadiusBySides(2),
                  "border-bottom-left-radius": _vm.getBorderRadiusBySides(3),
                },
                _vm.modalContainerStyles,
              ],
            },
            [
              _vm.showHeader
                ? _c(
                    "div",
                    {
                      staticClass: "modal-header",
                      class: {
                        "is-mobile": _vm.isMobile,
                        "is-tabs": _vm.headerVariant === "tabs",
                      },
                    },
                    [_vm._t("modalHeader")],
                    2
                  )
                : _vm._e(),
              _vm._t("default"),
              _vm._t("errorMsg"),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }